export default __webpack_public_path__ + "static/media/2.337af7e6.jpeg";